<template>
  <ValidationObserver v-slot="{ passes }" ref="observer">
    <v-dialog v-model="dialog" max-width="520px" :fullscreen="$vuetify.breakpoint.mdAndDown || dialogFullScreen"
              :hide-overlay="$vuetify.breakpoint.mdAndDown" scrollable no-click-animation>
      <v-card>
        <v-toolbar dark color="primary" :max-height="$vuetify.breakpoint.mdAndUp ? 64 : 56">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Paramètres de la page d'avis</v-toolbar-title>
          <v-progress-linear :active="saveLoading" :indeterminate="saveLoading" absolute bottom color="lime" />
          <div class="flex-grow-1" />
          <v-toolbar-items>
            <v-btn v-if="$vuetify.breakpoint.mdAndUp" icon @click="dialogFullScreen = !dialogFullScreen">
              <v-icon v-if="dialogFullScreen === true">mdi-fullscreen-exit</v-icon>
              <v-icon v-else>mdi-fullscreen</v-icon>
            </v-btn>
<!--            <v-btn dark text :disabled="!atLeastOneSelected || saveLoading" @click="passes(submit)">-->
            <v-btn dark text :disabled="saveLoading" @click="passes(submit)">
              <v-icon>mdi-content-save-outline</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="pt-4 text--white">
<!--          <v-alert v-if="!atLeastOneSelected" dense outlined type="warning" class="mb-4">-->
<!--            Vous devez sélectionner au moins une option.-->
<!--          </v-alert>-->
          <div class="body-2 mb-2">
            {{ $t('components.account.settings_introduction')}}
          </div>
          <v-checkbox v-model="displayStars" :true-value="1" :false-value="0" :label="'Afficher les étoiles'" :disabled="saveLoading" />
          <v-checkbox v-model="displayNps" :true-value="1" :false-value="0" :label="'Afficher la note NPS'" :disabled="saveLoading" />
          <v-checkbox v-model="displaySentiment" :true-value="1" :false-value="0" :label="'Afficher la note émotionnelle'" :disabled="saveLoading" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import AuthLogic from '@/logics/AuthLogic'
import ModelLogic from '@/logics/ModelLogic'
import { EventBus } from '@/services/Request'

export default {
  name: 'RatingDisplaySettingsDialog',
  components: { ValidationObserver },
  data: () => ({
    dialog: false,
    dialogFullScreen: false,
    saveLoading: false,
    displayStars: 0,
    displayNps: 0,
    displaySentiment: 0,
  }),
  computed: {
    // atLeastOneSelected () {
    //   return !!(this.displayStars || this.displayNps || this.displaySentiment)
    // }
  },
  methods: {
    openDialog () {
      return new Promise(resolve => {
        this.initFromUserMetas()
        this.dialog = true
        resolve()
      })
    },
    closeDialog () {
      return new Promise(resolve => {
        this.dialog = false
        resolve()
      })
    },
    initFromUserMetas () {
      try {
        const user = AuthLogic.user()
        const metas = (user && Array.isArray(user.metas)) ? user.metas : []
        const getNum = (key, fallback = 0) => {
          const m = metas.find(mm => mm.key === key)
          if (!m) return fallback
          const v = m.value
          if (v === 1 || v === '1' || v === true || v === 'true') return 1
          if (v === 0 || v === '0' || v === false || v === 'false') return 0
          return v ? 1 : 0
        }
        this.displayStars = getNum('rating_display_stars', 1)
        this.displayNps = getNum('rating_display_nps', 1)
        this.displaySentiment = getNum('rating_display_weighted_sentiment', 0)
      } catch (e) {
        // defaults
        this.displayStars = 1
        this.displayNps = 1
        this.displaySentiment = 0
      }
    },
    async submit () {
      this.saveLoading = true
      const userId = AuthLogic.user().id
      const ops = [
        { key: 'rating_display_stars', value: this.displayStars },
        { key: 'rating_display_nps', value: this.displayNps },
        { key: 'rating_display_weighted_sentiment', value: this.displaySentiment }
      ]
      // On utilise PUT /users/{uuid}/metas (une meta à la fois) pour ne pas écraser
      // les autres metas de l'utilisateur (ex: permission_denied_overrides)
      Promise.all(ops.map(op => ModelLogic.updateOne('users', userId + '/metas', op)))
          .then(async () => {
            this.saveLoading = false;
            await AuthLogic.loadUser()
            this.closeDialog()
            EventBus.$emit('show-snackbar', { text: 'Préférences enregistrées', timeout: 2500 })
            EventBus.$emit('user-account-updated', { type: 'display-settings' })
          })
          .catch((error) => {
            console.error(error)
            this.saveLoading = false
            EventBus.$emit('show-snackbar', { text: "Erreur lors de l'enregistrement des préférences", color: 'error', timeout: 4000 })
          })
    }
  }
}
</script>
